<template>
  <div class="substandards-list">
    <template v-if="!singleSubstandardBullet && orderedSubstandards">
      <ol :type="olType">
        <li
          v-for="substandard in orderedSubstandards"
          :key="substandard.standard_long_ref"
          v-html="substandard.substandard_text || substandard.standard_text"/>
      </ol>
    </template>

    <template v-if="singleSubstandardBullet && singleSubstandardText">
      <ol :type="olType" :start="listItemIndexForCharacter(singleSubstandardBullet)">
        <li
          v-html="singleSubstandardText"/>
      </ol>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SubstandardBullets',
  props: {
    orderedSubstandards: {
      type: Array,
      default: null
    },
    olType: {
      type: String,
      default: 'a'
    },
    singleSubstandardBullet: {
      type: String,
      default: ''
    },
    singleSubstandardText: {
      type: String,
      default: ''
    }
  },
  methods: {
    listItemIndexForCharacter(bulletChar) {
      if (isNaN(parseInt(bulletChar))) {
        let startCharCode = this.olType.charCodeAt(0)
        let letterCharCode = bulletChar.charCodeAt(0)
        return letterCharCode - startCharCode + 1
      }
      return bulletChar
    }
  }
}
</script>
